<template lang="pug">
  div(v-cloak)
    div#loading(v-show="loading" v-bind:style="{minHeight: winHeight + 'px' }")
      v-layout(row wrap)
        v-flex(xs12)
          img(src='/static/images/loading.png' width=350)
        v-flex(xs12)
          span.primary--text Loading
    div(v-show='!loading')
      CommonHeader
      v-layout.justify-center#top(row wrap)
        img.top_img(src="/static/images/top_main.png" alt='ドイツの郷土料理をお手軽に！')
      main.mt-3
        v-container
          v-layout.justify-center(row wrap)
            h1.text-xs-center ビュルガー社の
              br
              | ミニマウルタッシェン・
              br.sm
              | フィンガーポテト・シュペッツレ
            v-flex(xs12)
              p.my-4.text-xs-center
                | ドイツ料理を手軽に味わえるBÜRGER社の冷凍食品。
                br
                | ご家庭やお店のメニューとしてお使いいただけます。
                br
                | ドイツの味をお手軽に味わってみませんか？
            v-container
              v-layout(row wrap)
                v-flex.mx-auto.pa-1.image_btn(xs6 md3 v-for='(item,index) in categorySingleItem' :key='item.key' v-scroll-to="'#' + item.key")
                  v-img(:src="'/static/images/image_' + item.key + '.png'")
                  v-layout.image_btn_text.primary.white--text(row wrap)
                    v-flex(xs12)
                      span.de {{ item.de }}
                    v-flex(xs12)
                      span.mincho.secondary--text(style='font-size: .8rem;white-space: pre-wrap;') {{ item.name }}
          v-layout.justify-center(row wrap)
            v-container#notes
              v-layout.notes_wrap.py-3
                v-layout(row wrap v-show="!item.hide" v-for='(item, index) in schedule' :key="`s-${index}`")
                  v-flex(xs12).mb-3
                    i.primary--text.material-icons date_range
                    h3 {{ item.title }}
                    dl
                      dt.secondary--text {{ item.date }}
                      dd {{ item.topic }}
                        ul(v-for='(row, rowIndex) in item.list' :key="`s-l-${rowIndex}`")
                          li {{ row.topic }}
                v-layout.px-3(row wrap)
                  v-flex(xs12)
                    i.red--text.text--darken-1.material-icons info
                    h3.red--text.text--darken-1 重要なお知らせ
                    dl
                      dt いつもご愛顧いただきありがとうございます。
                        br
                        | この度、大谷商会の楽天ショップ、amazonショップが開店いたしました。
                        br
                        | 2020年10月1日より、オンラインショップのページを切り替えさせていただきました。
                        br
                        | 今後とも引き続き、よろしくお願いいたします。
                    v-layout.py-2(row wrap)
                      ul
                        li
                          a.mt-2(href='https://item.rakuten.co.jp/otani-trading-foods/') 楽天ショップページはこちら
                        li
                          a.mt-2(href='http://www.amazon.co.jp/dp/B08JCC2Y5F?ref=myi_title_dp') amazonショップページはこちら
            v-layout(row wrap)
              v-layout.item_wrap.anchor(row wrap v-for='(item,index) in categorySingleItem' :key='item.key' :id='item.key')
                v-container.mb-2
                  v-layout.justify-center(row wrap)
                    v-flex.title_wrap(xs12)
                      img(:src="'/static/images/illust_' + item.key + '.png'" :alt="item.name + 'イラスト'")
                      h2.my-3.de.white--text(style='font-size: 2.5rem')
                        | {{ item.de }}
                        span.mincho.secondary--text(style='display: block;font-size:1.1rem')
                          | {{ item.name }}
                    p.mb-3.mincho {{ item.catchphrase }}
                  v-layout(row wrap)
                    v-flex(xs12 sm7)
                      v-img.img_l(:src="'/static/images/image_' + item.key + '.png'" :alt="item.name + 'イメージ写真'" cover)
                    v-flex(xs12 sm5)
                      v-flex.img_s(md12 :style="{ backgroundImage:'url(../../../../../static/images/image_s_' + item.key + '.png)'}")
                      v-layout.comment_wrap.primary.pa-2.pr-3(row wrap)
                        v-img(xs6 :src="'/static/images/item_comment_' + item.key + '.svg'" :alt='item.comment_alt' contain max-width=180)
                        v-img(xs6 :src="'/static/images/item_' + item.key + '.png'" :alt="item.name + '商品写真'" style='margin-left:10%' max-width=120 width=120)
                  v-layout.mt-3(row wrap)
                    v-flex(md6)
                      dl
                        span
                          dt 主要原材料
                          dd.mb-2 {{ item.ingredients }}
                          dt 本品に含まれるアレルギー物質
                          dd {{ item.allergen }}
                        router-link(:to="'/ingredients#' + item.key ") 原材料の詳しい情報はこちら
                    v-flex.mt-2(md6)
                      router-link(:to="'/recipe#' + item.key ").recipe_btn
                        div
                          span {{ item.series }}で作る
          v-layout.justify-center(row wrap)
            img(src='/static/images/item_pic_spaetzle.png' width=250 height=176 alt='イラスト')

          v-layout#dlg.justify-center.my-5(row wrap)
            h2 BÜRGER社は
              br
              | ＤＬＧ国際品質競技会で金賞を受賞しています
            img.mb-4(src='/static/images/dlg_medal.png', alt='DLG国際品質競技会メダル' width=100 height=100)
            v-flex.text-xs-center(xs12)
              router-link(to='/dlg')
                v-btn(x-large flat center block outline round).primary.text-secondary ＤＬＧ国際品質競技会とは
            v-flex(xs12)
          v-layout#company.justify-center.py-5.my-3(row wrap)
            h2 1934年創立以来、
              br.sm
              | 品質にこだわり続ける食品製造会社
              br
              | ビュルガー社
            a(href='http://www.buerger.de/')
              img.mb-4(src="/static/logo_buerger.svg" alt='ビュルガー社ロゴ' width='250' style='margin:0 auto')
            v-flex.text-xs-center(xs12)
              router-link(to='/company')
                v-btn(x-large flat center block outline round).primary ビュルガー社とは
          v-layout(row wrap)#contact.justify-center.text-xs-center.color-primary
            v-flex(xs12) Contact
              v-flex.my-2.justify-center(xs12 sm4 offset-sm4)
                a(href='http://www.otani-shokai.com/')
                  img(src='/static/logo_otani-trading.svg' alt='大谷商会ロゴ' width='200' style='margin: 0 auto')
              h3 [輸入販売元]
                br
                | 株式会社大谷商会 国際部
              address.my-2 〒950-0814 新潟県新潟市東区逢谷内463
                br
                span TEL 025-275-8185
                span.ml-2 FAX 025-275-8186
              a.primary--text(href="mailto:kokusai@otani-shokai.com").mail E-mail: kokusai@otani-shokai.com
              br
              a.my-3(href="http://www.otani-shokai.com/") www.otani-shokai.com
      CommonFooter
</template>

<script>
import _ from 'underscore'
import { mapGetters, mapActions } from 'vuex'
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
    setTimeout(() => {
      this.loading = false
    }, 900)
  },
  data () {
    return {
      // Loading
      loading: true,
      // Window Size
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      addedToastr: false,
      deniedToastr: false,
      items: [],
      schedule: [{
        hide: true,
        title: 'お盆期間中の配送スケジュールについて',
        list: [{
          'topic': 'お盆前最終出荷分は8月7日（金）AM11時までとなります。'
        }, {
          'topic': '8月7日（金）AM11時以降のご注文分はお盆明けの手配になりますのでご注意ください。'
        }, {
          'topic': 'お盆明けは8月17日（月）からご注文を承ります。'
        }]
      }],
      news: [{
        title: 'NEWS',
        date: '2020/9/19',
        topic: '楽天ショップページへのリンクを追加しました。',
        past: [{
          date: '2020/6/30',
          topic: 'HPをリニューアルしました。マウルタッシェンの販売を終了しました。'
        }]
      }],
      notes: [{
        list: [{
          'topic': '土日祝にいただいたご注文につきましては、翌営業日の確認となります。'
        }, {
          'topic': 'お届け日は土日限定になります。ご了承ください。ご都合の悪い場合は TEL025-275-8185 までご相談ください。'
        }]
      }],
      yoridori1: null,
      yoridori2: null,
      yoridori3: null,
      yoridori1Toastr: false,
      yoridori2Toastr: false,
      yoridori3Toastr: false,
      uniquedToastr: false
    }
  },
  created () {
    this.items = this.samples.map(sample => JSON.parse(JSON.stringify(sample)))
  },
  computed: {
    ...mapGetters('app', {samples: 'items'}),
    ...mapGetters('app/shop', ['cart']),
    categorySingleItem () {
      return _.filter(this.items, function (item) {
        return item.category === 'singleItem'
      })
    },
    categorySpecials () {
      return _.filter(this.items, function (item) {
        return item.category === 'specials'
      })
    },
    categorySelects () {
      return _.filter(this.items, function (item) {
        return item.category === 'selects'
      })
    }
  },
  methods: {
    ...mapActions('app/shop', ['addItemToCart']),
    addCart (item) {
      item.num = parseInt(item.num, 10)
      if (Number.isNaN(item.num) || item.num <= 0) {
        this.deniedToastr = true
        item.num = null
        return true
      }
      this.addItemToCart(item)
      this.addedToastr = true
      item.num = null
    },
    addCartYoridori (item) {
      if (!this.yoridori1) {
        this.yoridori1Toastr = true
        return true
      }
      if (!this.yoridori2) {
        this.yoridori2Toastr = true
        return true
      }
      if (!this.yoridori3) {
        this.yoridori3Toastr = true
        return true
      }
      const selected = [this.yoridori1, this.yoridori2, this.yoridori3].sort((a, b) => a.value - b.value)
      const uniqued = [...new Set(selected)]
      if (uniqued.length !== 3) {
        this.uniquedToastr = true
        return true
      }
      item.num = parseInt(item.num, 10)
      if (Number.isNaN(item.num) || item.num <= 0) {
        this.deniedToastr = true
        item.num = null
        return true
      }
      const copy = JSON.parse(JSON.stringify(item))
      copy.uuid = uniqued.map(u => u.value).join(',')
      copy.key = `${copy.key} [${uniqued.map(u => u.value).join(',')}]`
      copy.name = `${copy.name} [${uniqued.map(u => u.text).join(',')}]`
      this.addItemToCart(copy)
      this.addedToastr = true
      item.num = null
      this.yoridori1 = null
      this.yoridori2 = null
      this.yoridori3 = null
    }
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
screen-md = 1264px
breakpoint(bpName)
    for name in bpName
        if name == 'lg-up'
            @media only screen and (min-width: screen-md + 1)
                {block}
        if name == 'md-up'
            @media only screen and (min-width: screen-sm + 1)
                {block}
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs + 1)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}
// color
$color-primary = #502e28
$color-secondary = #ecddbc

// font
@import url('https://fonts.googleapis.com/css?family=Satisfy&display=swap');

#top
  height 600px
  margin-top 80px
  background url(../../../../../static/images/top_bg.png) no-repeat
  background-size cover
  background-position center
  display flex
  justify-content center
  align-items center
  img
    max-width 600px
    margin 0 auto
  +breakpoint(sm)
    height 400px
    img
      width 300px
h1
  font-size 1.5rem
.de
  font-family: 'Satisfy', cursive
.item_wrap
  .title_wrap
    position relative
    h2
      background $color-primary
    img
      width 20%
      position absolute
      top -2rem
  .img_l
    height 450px
    +breakpoint(xs)
      height 200px
  .img_s
    height 300px
    background-size cover
    background-position bottom
    +breakpoint(xs)
      height 200px
  .comment_wrap
    height 150px
    +breakpoint(xs)
      height 150px
  p
    font-size 1rem
    white-space pre-wrap
    text-align center
    font-weight 700
  dt,dd,a
    font-size .7rem
  dt
    border-bottom 1px solid $color-primary
    font-weight 700
  .recipe_btn
    background-size cover
    display flex
    align-items center
    justify-content flex-end
    cursor pointer
    text-decoration none
    div
      width 180px
      height 126px
      background url(../../../../../static/images/btn_recipe.png) no-repeat
      background-size 100%
      background-position top center
      display flex
      justify-content center
      span
        font-size .75rem
        font-weight 700
        margin-top 20px
    &:hover
      div
        background-position bottom center
  .opinion_wrap
    background background url(../../../../../static/images/linedpaper.png) repeat
    h4
      border-bottom 1px dotted $color-primary
    ul
      width 100%
      li
        font-size .8rem
        line-height 1.8
        list-style-type disc
        float left
        width 33%
#notes
  .notes_wrap
    border-top 1px solid $color-primary
    border-bottom 1px solid $color-primary
  i
    float left
    font-size 1.4rem
    margin -2px 5px 0 0
  h3
    font-size .9rem
    text-align left
  dt,dd
    font-size .9rem
  dt
    float left
    padding 0 10px 0 5px
    font-weight bold
    +breakpoint(sm)
      float none
      padding 0 10px 0 0
  ul
    margin-left 1rem
    li
      font-size 0.9rem
      list-style-type circle
      padding-left -1rem
#dlg,#company
  h2
    font-size 1.2rem
    background none
    color $color-primary
  a
    width 250px
    display inline-block
    margin 0 auto
    text-decoration none
#contact
  h2
    font-size 1.5rem
  h3
    font-size 1rem
  address,a
    font-size .8rem
    text-decoration none
//IE11
_:-ms-lang(x)::-ms-backdrop, .top_img
  margin-left 0!important
</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Top/index.vue